import Params from './Params';
import Request from './Request';
import ListingTemplates from './ListingTemplates';
import Pagination from './Pagination';
import EventFilters from './EventFilters';
import Cookies from './Cookies';

export default class Listing {
  constructor() {
    this.listing = document.querySelector('.js-listing-container');
    this.listing_type = this.listing.dataset.listingType;
    this.data_endpoint = this.listing.dataset.urlEndpoint;
    this.results_container = this.listing.querySelector('.js-listing-content');
    this.num_results_container = this.listing.querySelector('.js-listing-num-results');
    this.loading_container = this.listing.querySelector('.js-loading-container');
    this.filters = this.listing.querySelectorAll('.js-listing-filter');
    this.monthPickerButtons = this.listing.querySelectorAll('.js-month-picker button');
    this.monthPickerSelect = this.listing.querySelector('.js-month-select');
    this.current_duration_start = '';
    this.current_duration_end = '';
    this.submit = this.listing.querySelector('.js-listing-submit');
    this.params = new Params();
    this.templates = new ListingTemplates();
    this.pagination = new Pagination();
    this.event_bus = window.event_bus;
    this.num_per_page = 9;

    //CRO SPECIAL OFFERS ENHANCEMENT
    this.cookies = new Cookies();
    if(this.cookies.getCookie('cro_enhanced_special_offers') == 'true' && this.listing_type == 'special-offer') {
      this.listing_type = 'special-offer-cro';
    }

    if (this.listing_type == 'events') {
      this.event_filters = new EventFilters();
    }

    if (this.monthPickerButtons) {
      this.monthPickerButtons.forEach(button => {
        button.addEventListener('click', (e) => {
            this.handleMonthSelection(e.target);
        });
      });
    }

    if (this.monthPickerSelect) {
      this.monthPickerSelect.addEventListener('change', (e) => {
        this.handleMonthSelection(e.target.value);
        this.updateResults();
      });
    }

    if(this.submit) {
      // We need a useless submit button for ADA purposes
      this.submit.addEventListener('click', (event) => {
        event.preventDefault();
      });
    }

    this.filters.forEach((filter) => {
      if (filter.dataset.filterType == 'tax-select' || filter.dataset.filterType == 'sort' || filter.dataset.filterType == 'poi-type-select' || filter.dataset.filterType == 'meta' || filter.dataset.filterType == 'meta-array') {
        //if we have data saved in the url and the value is in the dropdown, set it now
        var filter_value = filter.querySelector('.js-filter-value');
        var url_value = this.params.get(filter_value.id);

        if (url_value && filter_value.querySelector('option[value="' + url_value + '"]')) {
          filter_value.value = url_value;
        }

        //when a filter is updated, pull new content
        filter.addEventListener('change', () => {
          this.pagination.current_page = 1;
          this.updateFilterParams();
          this.updateResults();
        });
      } else if (filter.dataset.filterType == 'event-duration') {
        var url_value = this.params.get('event-duration');

        if (url_value == filter.dataset.filterValue && url_value != 'custom-dates') {
          this.event_filters.durationChanged(filter);
        }

        //when a filter is updated, pull new content
        filter.addEventListener('click', (event) => {
          this.event_filters.durationChanged(event.target);
          if (this.event_filters.current_duration == 'custom-dates') {
            this.event_filters.openCalendar();
          } else {
            this.pagination.current_page = 1;
            this.updateFilterParams();
            if (event.target.classList.contains('--active')) {
              this.event_filters.updateTempStatusBar(event.target.dataset.filterValue);
            }
            this.event_filters.updateFilterStatusBar();
            this.updateResults();
          }
        });
      } else if (filter.dataset.filterType == 'event-category') {
        var selected_category = this.listing.dataset.selectedCategory;

        if (selected_category && this.listing.querySelector('*[data-filter-value="' + selected_category + '"]')) {
          this.event_filters.unpackCategories(selected_category);

          if (this.event_filters.current_categories.includes(filter.dataset.filterValue)) {
            this.event_filters.categoryChanged(filter);
          }
        } else {
          var url_value = this.params.get('event-category');

          if (url_value) {
            this.event_filters.unpackCategories(url_value);

            if (this.event_filters.current_categories.includes(filter.dataset.filterValue)) {
              this.event_filters.categoryChanged(filter);
            }
          }
        }

        //when a filter is updated, pull new content
        filter.addEventListener('click', (event) => {
          this.event_filters.categoryChanged(event.target);
          this.pagination.current_page = 1;
          this.updateFilterParams();
          if (event.target.classList.contains('--active')) {
            this.event_filters.updateTempStatusBar(event.target.querySelector('.js-category-label').innerText);
          }
          this.event_filters.updateFilterStatusBar();
          this.updateResults();
        });
      }
    });

    if (this.listing_type == 'events') {
      //on calendar success logic
      this.event_bus.on('calendar-success', () => {
        this.pagination.current_page = 1;
        this.updateFilterParams();
        this.event_filters.updateTempStatusBar('custom-dates');
        this.event_filters.updateFilterStatusBar();
        this.updateResults();
      });

      //update the filter message bar
      this.event_filters.updateFilterStatusBar();
    }

    //allow other scripts to request refreshes
    this.event_bus.on('refresh-listing', () => {
      this.updateResults();
    });

    //setup pagination
    var page_value = this.params.get('page-num');
    if (page_value) {
      this.pagination.current_page = parseInt(page_value);
    }
    this.pagination.container.addEventListener("click", (event) => {
      if (event.target.classList.contains('js-pagination-item')) {
        this.pagination.current_page = parseInt(event.target.dataset.page);
        this.updateFilterParams();
        this.updateResults();
        this.scroll();
      }
    });
    this.pagination.button_previous.addEventListener('click', (event) => {
      this.pagination.current_page -= 1;
      this.updateFilterParams();
      this.updateResults();
      this.scroll();
    });
    this.pagination.button_next.addEventListener('click', (event) => {
      this.pagination.current_page += 1;
      this.updateFilterParams();
      this.updateResults();
      this.scroll();
    });

    this.updateResults();
  }

  updateFilterParams() {
    this.filters.forEach((filter) => {
      if (filter.dataset.filterType == 'tax-select' || filter.dataset.filterType == 'sort' || filter.dataset.filterType == 'poi-type-select' || filter.dataset.filterType == 'meta' || filter.dataset.filterType == 'meta-array') {
        var filter_value = filter.querySelector('.js-filter-value');
        if (filter_value.value != "") {
          this.params.set(filter_value.id, filter_value.value);
        }
      }
    });

    if (this.listing_type == 'events') {
      //set the duration and category values
      if (this.event_filters.current_duration != "") {
        this.params.set('event-duration', this.event_filters.current_duration);
      }
      if (this.event_filters.packCategories() != "") {
        this.params.set('event-category', this.event_filters.packCategories());
      }
    }

    this.params.set('page-num', this.pagination.current_page);
  }

  clearResults() {
    this.results_container.innerHTML = "";
  }

  handleMonthSelection(selectedButton) {
    let selectedMonth;
  
    // Check where the selected month is coming from (either custom dropdown button for desktop or select dropdown for mobile)
    if (selectedButton.tagName === 'BUTTON') {
      selectedMonth = parseInt(selectedButton.getAttribute('data-month'), 10);
    } else {
      selectedMonth = parseInt(selectedButton, 10);
    }
    
    const currentDay = new Date().getDate();
    const currentMonth = new Date().getMonth();
    let currentYear = new Date().getFullYear();

    // Check if the selected month is before the current month and if so adjust the year by one to filter for next year's events
    if (selectedMonth < currentMonth + 1) {
      currentYear += 1;
    }

    let startDate = new Date(currentYear, selectedMonth - 1, 1); // First day of the selected month
    const endDate = new Date(currentYear, selectedMonth, 0); // Last day of the selected month

    if ((selectedMonth === currentMonth  + 1) && (currentDay > 1)) {
      startDate = new Date(currentYear, currentMonth, currentDay)
    }

    this.current_duration_start = startDate.toISOString().split('T')[0]; // Format: YYYY-MM-DD
    this.current_duration_end = endDate.toISOString().split('T')[0]; // Format: YYYY-MM-DD
    this.generateQueryString();
  }

  generateQueryString() {
    var queryString = new URLSearchParams();

    var metaQueryCounter = 0;

    this.filters.forEach((filter) => {
      var filter_value = '';
      if (filter.dataset.filterType == 'tax-select' || filter.dataset.filterType == 'sort' || filter.dataset.filterType == 'poi-type-select' || filter.dataset.filterType == 'meta' || filter.dataset.filterType == 'meta-array') {
        filter_value = filter.querySelector('.js-filter-value').value;
      } else if (filter.dataset.filterType == 'event-duration' && filter.classList.contains('--active')) {
        filter_value = filter.dataset.filterValue;
      }

      if (filter_value != '') {
        if (filter.dataset.filterType == 'tax-select') {
          let add_terms = filter.querySelector(`option[value="${filter_value}"]`)?.dataset.addTerms;
          
          if(add_terms) {
            queryString.append(filter.dataset.taxName, add_terms);
          } else {
            queryString.append(filter.dataset.taxName, filter_value);
          }
        } else if (filter.dataset.filterType == 'poi-type-select') {
          queryString.append('poi-type', filter_value);
        } else if (filter.dataset.filterType == 'sort') {
          if (filter_value == 'random') {
            queryString.set('random-seed-order', 'true');
          } else if (filter_value == 'az') {
            queryString.set('orderby', 'title');
            queryString.set('order', 'asc');
          } else if (filter_value == 'za') {
            queryString.set('orderby', 'title');
            queryString.set('order', 'desc');
          } else if (filter_value == 'most-recent') {
            queryString.set('orderby', 'date');
            queryString.set('order', 'desc');
          } else if (filter_value == 'popularity') {
            queryString.set('orderby', 'popularity');
            queryString.set('order', 'desc');
          }
        } else if (filter.dataset.filterType == 'meta' || filter.dataset.filterType == 'meta-array') {
          if (filter_value != "any") {
            queryString.append(`filter[meta_query][${metaQueryCounter}][key]`, filter.dataset.metaField);
            queryString.append(`filter[meta_query][${metaQueryCounter}][value]`, filter_value);

            if(filter.dataset.filterType == 'meta-array') {
              queryString.append(`filter[meta_query][${metaQueryCounter}][compare]`, 'LIKE');
            }

            metaQueryCounter += 1;
          }
        } else if (filter.dataset.filterType === 'event-duration') {
          queryString.set('event-duration', filter_value);
          if (this.current_duration_start && this.current_duration_end) {
            queryString.set('event-duration-start', this.current_duration_start);
            queryString.set('event-duration-end', this.current_duration_end);
          }
        }
      }
    });

    if (this.listing_type == 'events') {
      // set the duration and category values
      if (this.current_duration_start && this.current_duration_end) {
        queryString.set('event-duration', 'month');
        queryString.set('event-duration-start', this.current_duration_start);
        queryString.set('event-duration-end', this.current_duration_end);
      }
      if (this.event_filters.packCategories() != "") {
        queryString.set('event-category', this.event_filters.packCategories());
      }
    }

    queryString.set('per_page', this.num_per_page);
    queryString.set('page', this.pagination.current_page);

    return queryString.toString();
  }

  scroll() {
    //scroll to the proper area
    this.listing.style.scrollMargin = "60px";
    this.listing.scrollIntoView({
      behavior: "smooth",
      block: "start"
    });
  }

  updateResults() {
    this.clearResults();
    this.pagination.clear();
    this.loading_container.classList.add('--active');
    this.results_container.classList.remove('--active');

    new Request(this.data_endpoint + '?' + this.generateQueryString()).then((response) => {
      var posts = response['response'];
      var headers = response['headers'];

      //loop through each post and push it to the container
      posts.forEach((post) => {
        this.results_container.innerHTML += this.templates.render(this.listing_type, post);
      });

      //set the number of results found
      if (this.num_results_container) {
        var num_results = parseInt(headers.get('X-WP-Total'));
        
        if (num_results > 0) {
            var current_page = this.pagination.current_page;
            var num_per_page = this.num_per_page;

            // Calculate the start and end of the current results range
            var start_result = (current_page - 1) * num_per_page + 1;
            var end_result = Math.min(current_page * num_per_page, num_results);

            this.num_results_container.innerHTML = `<span class="--mobile-results-message">Showing ${start_result} - ${end_result} of </span>${num_results} result${num_results > 1 ? 's' : ''}`;
        } else {
          this.num_results_container.innerHTML = 'No Results Found';
        }
    }

      //update pagination
      this.pagination.num_pages = headers.get('X-WP-TotalPages');
      this.pagination.update();

      //show container again
      this.loading_container.classList.remove('--active');
      this.results_container.classList.add('--active');

      //add GTM events for website button
      this.listing.querySelectorAll('.gtm-referral-link').forEach((link) => {
        link.addEventListener('click', (e) => {
          window.dataLayer.push({
            'event': 'referral_click',
            'transaction': 'Website',
            'StakeholderCategory': link.dataset.category,
            'StakeholderName': link.dataset.name,
            'StakeholderType': link.dataset.type
          });
        });
      });

      //dispactch an event that the listing has loaded for other services
      window.dispatchEvent(new Event('listing-loaded'));
    }).catch((error) => {
      //error
      console.error(error);
    });
  }
}
